import { createFileRoute } from '@tanstack/react-router'

import { Homepage } from '~/pages/Homepage'
import { sharedQueryClient } from '~/query/shared-query-client'
import { priceQuery, statsQuery } from '~/query/options/options'

export const Route = createFileRoute('/')({
    ssr: true,
    component: Homepage,
    loader: async () =>
    {
        return Promise.all([sharedQueryClient.ensureQueryData(statsQuery()),
                sharedQueryClient.ensureQueryData(priceQuery())])
            .then(([stats, prices]) =>
            {
                return {
                    stats, prices,
                }
            })
    },
})
